// extracted by mini-css-extract-plugin
export var card = "_bv-c";
export var checkmark = "_bv-k";
export var childrenContainer = "_bv-6";
export var container = "_bv-b";
export var disabled = "_bv-9";
export var disabledChildren = "_bv-a";
export var focused = "_bv-1";
export var gray = "_bv-r";
export var green = "_bv-o";
export var icon = "_bv-g";
export var iconWrapper = "_bv-8";
export var imageCircle = "_bv-s";
export var large = "_bv-5";
export var lg = "_bv-j";
export var listItemContainer = "_bv-0";
export var md = "_bv-i";
export var medium = "_bv-4";
export var menu = "_bv-f";
export var red = "_bv-p";
export var rightArea = "_bv-7";
export var sectionContainer = "_bv-e _bv-b";
export var selected = "_bv-d";
export var sm = "_bv-h";
export var small = "_bv-3";
export var statusDot = "_bv-n";
export var statusDotContainer = "_bv-m";
export var text = "_bv-l";
export var xs = "_bv-2";
export var yellow = "_bv-q";